module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('f7-page', [(_vm.sellers) ? _c('table', {
    staticClass: "listSellerTable"
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("Identifiant")]), _vm._v(" "), _c('th', [_vm._v("SIREN")]), _vm._v(" "), _c('th', [_vm._v("Raison Sociale")]), _vm._v(" "), _c('th', [_vm._v("Email")]), _vm._v(" "), _c('th', [_vm._v("Date")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.sellers), function(seller) {
    return _c('tr', {
      key: seller.IdSeller
    }, [_c('td', [_vm._v(_vm._s(seller.SellerIdentifier))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(seller.Siren))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(seller.SocialReason))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(seller.Email))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.dateFormat(seller.Date)))])])
  }), 0)]) : _vm._e()])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-1feb94bd", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1feb94bd","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/LMSGiframe/ListSellersFromApplicationForm.vue
// module id = 2359
// module chunks = 2